var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "d-flex px-0 just-content-center align-items-center",
    attrs: {
      "id": "admin-container",
      "fluid": ""
    }
  }, [(_vm.$route.path === '/login') ? [_c('AdminLogin')] : (_vm.$route.path === '/forgot-password') ? [_c('AdminForgotPassword')] : (_vm.$route.path === '/reset-password') ? [_c('AdminResetPassword')] : (_vm.$route.path === '/signup') ? [_c('AdminSignUp')] : (_vm.$route.path === '/verify') ? [_c('Verify')] : (_vm.$route.path === '/resend-code') ? [_c('ResendCode')] : (_vm.$route.path === '/who-are-you') ? [_c('WhoAreYou')] : (_vm.$route.path === '/payment') ? [_c('Payment')] : (_vm.$route.path === '/payment/confirmed') ? [_c('PaymentSuccess')] : (_vm.$route.path === '/payment/failure') ? [_c('PaymentFailure')] : (_vm.$route.path === '/unsubscribe') ? [_c('Unsubscribe')] : (_vm.$route.path === '/survey') ? [_c('Survey')] : (_vm.$route.path === '/biometrics') ? [_c('Biometrics')] : [_c('div', {
    staticClass: "h-100 w-100 d-flex",
    attrs: {
      "id": "main-container"
    }
  }, [_c('SidebarContainer', {
    attrs: {
      "id": "sidebar"
    }
  }), _vm._v(" "), _c('div', {
    class: !_vm.displayMobileNav ? 'no-margin' : '',
    attrs: {
      "id": "main-content-container"
    }
  }, [_c('TopBar', {
    staticClass: "px-2"
  }), _vm._v(" "), _c('MainContent', {
    staticClass: "px-2"
  })], 1)], 1)]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e16a173","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Admin.vue
// module id = 7Jo1
// module chunks = 2